import request from '@/utils/http';
// -----------------综合评分技术分-----------------
// 综合评分技术分+商务分
export const scoreList = (params) => {
    return request({
        url: `/api-srm-web/bid/queryScoreAttributeGroupBy`,
        method: 'post',
        data: params
    });
};
// 保存
export const saveList = (params) => {
    return request({
        url: `/api-srm-web/bid/batchUpdateBidScoreTemplare`,
        method: 'post',
        data: params
    });
};
// 删除
export const delList = (params) => {
    return request({
        url: `/api-srm-web/bid/deleteCompositBatchInfo`,
        method: 'post',
        data: params
    });
};
// 导入报价模板
export const fileImport = (params) => {
    return request({
        url: `/api-srm-web/bid/importCompositeScore`,
        method: 'post',
        data: params
    });
};
// 导出
export const fileExport = (params) => {
    return request({
        url: `/api-srm-web/bid/exportCompositeScore`,
        method: 'post',
        data: params
    });
};
// ----------------标书合同---------------
// 保存
export const contractSave = (bidNo, params) => {
    return request({
        url: `/api-srm-web/bid/bidHeadUpdate/${bidNo}`,
        method: 'put',
        data: params
    });
};
// 招标文件列表
export const uploadList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/getBidModuleFiles`,
        method: 'post',
        data: params
    });
};
// 招标文件列表(新)
export const uploadListNew = (params) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/queryBidHeadModuleFiles`,
        method: 'post',
        data: params
    });
};
// 招标文件上传
export const uploadTemplate = (params, url) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/creates${url}`,
        method: 'post',
        data: params
    });
};
// 招标文件上传替换
export const updateModuleFile = (params, id) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/updateModuleFile/${id}`,
        method: 'put',
        data: params
    });
};
// 标书文件最新模板下载
export const tplDownload = (params) => {
    return request({
        url: `/api-srm-file/bid/bidHead/moduleFile/tplDownload`,
        method: 'get',
        params 
    });
};
// 招标文件删除
export const delFile = (id, url) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFile/${id}${url}`,
        method: 'delete'
    });
};
// 合同文件修改
export const uploadPost = (url, params) => {
    return request({
        url: `/api-srm-web/bid/bidModuleFilesBatchUpdate${url}`,
        method: 'post',
        data: params
    });
};
// 进入查询登入人的分公司服务平台等
export const getCompanySite = (params) => {
    return request({
        url: `/api-mdm//searchPlatform`,
        method: 'get',
        params: params
    });
};
// 合同模板选择
export const contractSelect = (params, url) => {
    return request({
        url: `/api-srm-web/bid/attachmentDownload${url}`,
        method: 'post',
        data: params
    });
};
// -------------组织成员--------------
// 查询
export const orgList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidTeam/queryPage`,
        method: 'post',
        data: params
    });
};
// 新增
export const addOrgList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidTeamInsertBatch`,
        method: 'post',
        data: params
    });
};
// 删除
export const delOrgList = (params) => {
    return request({
        url: `/api-srm-web/bid/teamDeleteBatch`,
        method: 'post',
        data: params
    });
};
// 查看是否推送评分
export const seachIspull = (params) => {
    return request({
        url: `/api-srm-web/bid/bidScoringPushScore/${params}`,
        method: 'get'
    });
};
// MIP审核
export const mipExamine = (params) => {
    return request({
        url: `/api-srm-web/bid/headIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// MIP审核特批
export const mipSpecial = (params, flag) => {
    return request({
        url: `/api-srm-web/bid/headIflowCreateDraft?flag=${flag}`,
        method: 'post',
        data: params
    });
};
// 查看是否发起了流程
export const isFlower = (params) => {
    return request({
        url: `/api-srm-web/bid/bidAudits`,
        method: 'post',
        data: params
    });
};
// 查询mip流程
export const seachMip = (params) => {
    return request({
        url: `/api-iflow/queryOneInstance`,
        method: 'post',
        data: params
    }).then(res => res);
};
// 查询是否维护了技术和商务
export const seachMaintain = (params) => {
    return request({
        url: `/api-srm-web/bid/bidMintenance/${params}`,
        method: 'get'
    });
};
// -------------------报价模板-----------
// 表格列表
export const quotedList = (params) => {
    return request({
        url: `/api-srm-web/bid/bidQuoteTemplate/getParentAndChildList`,
        method: 'post',
        data: params
    });
};
// 删除
export const delTemList = (url, params) => {
    return request({
        url: `/api-srm-web/bid/TemplateDeleteBatch${url}`,
        method: 'post',
        data: params
    });
};
// 修改
export const modifyList = (url, params) => {
    return request({
        url: `/api-srm-web/bid/TemplateBatchUpdate${url}`,
        method: 'post',
        data: params
    });
};
// 获取招标模板等信息
export const templateInfo = (params) => {
    return request({
        url: `/api-srm-web/bid/bidQuoteTmptHeader/getOneBidQuoteTmpInfoByCode`,
        method: 'post',
        data: params
    });
};
// 判断是否已经进行了模板维护的
export const isMaintainTem = (params) => {
    return request({
        url: `/api-srm-web/bid/bidQuoteTemplate/bidQuoteExportCount`,
        method: 'post',
        data: params
    });
};
// 选完招标模板后保存起来
export const saveTempalte = (params) => {
    return request({
        url: `/api-srm-web/bid/bidHead/updateBidHeadTemplateCode`,
        method: 'post',
        data: params
    });
};
// 拦标价审批mip
export const bidPrice = (params) => {
    return request({
        url: `/api-srm-web/bid/hurdlesIflowCreateDraft`,
        method: 'post',
        data: params
    });
};
// 公布拦标价
export const blockPrice = (params) => {
    return request({
        url: `/api-srm-web/bid/templateQuoteRange`,
        method: 'post',
        data: params
    });
};
// 查询拦标价是否维护
export const seachPrice = (params) => {
    return request({
        url: `/api-srm-web/bid/bidQuoteTemplate/bidpriceCheck/${params}`,
        method: 'get'
    });
};
// 查询MIP流程状态
export const mipFlowType = (params) => {
    return request({
        url: `/api-srm-web/bid/bidAudits`,
        method: 'post',
        data: params
    });
};
// 线路导出
export const exportLine = (params) => {
    return request({
        url: `/api-lcp-report/report/task/export`,
        method: 'post',
        data: params
    });
};
// 标书复制
export const copyBidHead = (params) => {
    return request({
        url: `/api-srm-web/bid/copyBidHead`,
        method: 'post',
        data: params
    });
};
// 标书复制-获取标段
export const getExtStrsByBidNo = (bidNo) => {
    return request({
        url: `/api-srm-web/bid/getExtStrsByBidNo?bidNo=${bidNo}`,
        method: 'post'
    });
};
// 检查投标保证金金额押金比例
export const checkDigitalValue = (params) => {
    return request({
        url: `/api-srm-web/checkDigitalValue`,
        method: 'post',
        data: params
    });
};
// 导出模板、明细
export const exportBidQuote = (url, bidNo, templateCode) => {
    return request({
        url: `${url}/${bidNo}/${templateCode}`,
        method: 'get',
        responseType: 'arraybuffer'
    });
};
// 获取多规则报价模板表头信息
export const getBidQuoteTempHeader = data => {
    return request({
        url: '/api-srm-web/bid/getBidQuoteTemplateDataHeader',
        method: 'post',
        data
    });
};
// 获取多规则报价模板表数据
export const getBidQuoteTempData = data => {
    return request({
        url: '/api-srm-web/bid/getBidQuoteTemplateData',
        method: 'post',
        data
    });
};
// 导出模板、明细-JSON格式
export const exportBidQuoteJSON = (url, bidNo, templateCode) => {
    return request({
        url: `${url}/${bidNo}/${templateCode}`,
        method: 'get'
    });
};

// 根据服务平台编码集合查询 服务平台、经营中心、分公司
export const listCompanyBySiteCodes = data => {
    return request({
        url: `/api-mdm/escompany/listCompanyBySiteCodes`,
        method: 'post',
        data,
    });
};

// 查询规模输入框是否可以输入
export const changeBusinessScaleEnable = data => {
    return request({
        url: `/api-srm-web/bid/bidHead/changeBusinessScaleEnable`,
        method: 'post',
        data,
    });
};

// 地址转换导入
export const importAddressAnalyzer = data => {
    return request({
        url: `/api-gis/api-file/importAddressAnalyzer`,
        method: 'post',
        data,
    });
};

// 地址转换文件模板
export const downloadTemplate = params => {
    return request({
        url: `/api-gis/api-file/downloadTemplate`,
        method: 'get',
        params,
        responseType: 'arraybuffer'
    });
};

// 地址转换文件转换列表
export const ossFilePage = params => {
    return request({
        url: `/api-oss/oss/file/info/page`,
        method: 'get',
        params,
    });
};
export const getSearchEbPlace = (params) => {
    return request({
        // url: `/api-mdm/searchEbPlace?ebplType=PLACE_STREET&ebplIsAble=ENABLE`,
        url: `/api-mdm/searchEbPlace`,
        method: 'get',
        params: params,
    });
};

export const matchDigitalValueValidRule = (data) => {
    return request({
        url: `/api-srm-web/bid/matchDigitalValueValidRule`,
        method: 'post',
        data,
    });
};
